export default "__VITE_PUBLIC_ASSET__f75b7d27__"